export default {
	accounts: {
		name: 'Account | Accounts',
		id: 'Account-ID',
		journal: '@:entity.journal.name',
		approve_all_journals: 'Approve All Journals',
		reject_all_journals: 'Reject All Journals',
		show_document: 'Show Document',
		hide_document: 'Hide Document',
		default: 'Default',
		reviews: 'Reviews',
		reviewed: 'reviewed',
		updated: 'updated',
		assign_reviewer: 'Assign Reviewer',
		select_people_to_continue: 'Please select people to continue',
		read: 'Read',
		write: 'Write',
		accountingYear: 'Fiscal Year',
		unit: 'Unit',
	},
}
